import React, { useEffect, useState } from "react";
import "../styles/modalFavori.css";

function getWhatsappText(produits) {
  if (!produits || produits.length === 0) return "Mes favoris AdaWall";
  let text = "Mes favoris AdaWall :\n";
  produits.forEach(prod => {
    // Utilise nomCategorie et nomCollection comme titre
    const nomProduit = `${prod.nomCategorie || ""}${prod.nomCollection ? " - " + prod.nomCollection : ""}`;
    text += `• ${nomProduit.trim() || "Sans nom"} (Réf: ${prod.idReference})`;

    text += `\n`;
  });
  return encodeURIComponent(text);
}

function ModalFavori({ open, onClose, lastAdded }) {
  const [favoris, setFavoris] = useState([]);
  const [produits, setProduits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!open) return;
    const favs = JSON.parse(localStorage.getItem("adawall_favorites") || "[]");
    setFavoris(favs);

    if (favs.length > 0) {
      setLoading(true);
      Promise.all(
        favs.map(idRef =>
          fetch(`https://adawall.ma/php/api/images_par_reference.php?idReference=${idRef}`)
            .then(res => res.json())
            .then(images => ({
              idReference: idRef,
              image: images[0]?.source || null // première image
            }))
        )
      ).then(imagesData => {
        fetch("https://adawall.ma/php/api/reference.php")
          .then(res => res.json())
            .then(refs => {
              // Fusionne et trie pour mettre le dernier ajouté en premier
              let produits = favs.map(idRef => {
                const ref = refs.find(r => String(r.idReference) === String(idRef));
                console.log(ref); // Ajoute cette ligne pour voir les propriétés disponibles
                const imgData = imagesData.find(img => String(img.idReference) === String(idRef));
                return {
                  ...ref,
                  nomCategorie: ref?.nomCategorie,      // <-- Ajoute ici
                  nomCollection: ref?.nomCollection,    // <-- Ajoute ici
                  image: imgData?.image || null
                };
            });
            if (lastAdded) {
              produits = produits.sort((a, b) => {
                if (a.idReference === lastAdded) return -1;
                if (b.idReference === lastAdded) return 1;
                return 0;
              });
            }
            setProduits(produits);
            setLoading(false);
          });
      });
    } else {
      setProduits([]);
      setLoading(false);
    }
  }, [open, lastAdded]);

  if (!open) return null;

  return (
    <div className="modal-fav-backdrop">
      <div className="modal-fav-content" style={{minWidth: 400, maxWidth: 600}}>
        <button className="modal-fav-close" onClick={onClose}>&times;</button>
        <h3 className="modal-fav-title">MES FAVORIS</h3>
        {lastAdded && (
          <div className="modal-fav-success">
            Produit ajouté aux favoris
          </div>
        )}

        {loading ? (
          <div style={{padding: 30, textAlign: "center"}}>Chargement...</div>
        ) : favoris.length === 0 ? (
          <div style={{padding: 30, textAlign: "center", color: "#96292A"}}>Aucun produit favori.</div>
        ) : (
          <>
            <div className="modal-fav-list">
              {produits.map(prod => (
                <div key={prod.idReference} style={{
                  display: "flex", alignItems: "center", gap: 18, border: "1px solid #eee",
                  borderRadius: 8, padding: 10, background: "#f7f8fa", marginBottom: 8
                }}>
                  <img
                    src={prod.image ? `https://adawall.ma/uploads/${prod.image.trim()}` : "/assets/no-image.png"}
                    alt={prod.titre}
                    style={{width: 60, height: 60, objectFit: "cover", borderRadius: 6, border: "1px solid #e6e6e6"}}
                  />
                  <div style={{flex: 1}}>
                    <div style={{color: "#96292A", fontWeight: 700}}>Réf: {prod.idReference}</div>
                    <div style={{color: "#01367B", fontWeight: 500, fontSize: "1.01rem"}}>{prod.titre}</div>
                    {prod.nomCategorie && (
                      <div style={{color: "#555", fontSize: "0.97rem"}}>Catégorie: {prod.nomCategorie}</div>
                    )}
                    {prod.nomCollection && (
                      <div style={{color: "#555", fontSize: "0.97rem"}}>Collection: {prod.nomCollection}</div>
                    )}
                  </div>
                  <a href={`/reference/${prod.idReference}`} style={{
                    background: "#01367B", color: "#fff", borderRadius: 6, padding: "6px 14px",
                    textDecoration: "none", fontWeight: 600, fontSize: "0.98rem"
                  }}>Voir</a>
                </div>
              ))}
            </div>
            {/* Bouton WhatsApp en bas */}
            <div style={{textAlign: "center", margin: "18px 0 0 0"}}>
              <a
                href={`https://wa.me/?text=${getWhatsappText(produits)}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  background: "#25D366",
                  color: "#fff",
                  borderRadius: 6,
                  padding: "8px 18px",
                  fontWeight: 600,
                  fontSize: "1rem",
                  textDecoration: "none",
                  marginBottom: 8
                }}
              >
                <i className="fa-brands fa-whatsapp" style={{marginRight: 8, fontSize: "1.2em", verticalAlign: "middle"}}></i>
                Partager sur WhatsApp
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ModalFavori;